import { render, staticRenderFns } from "./EventPopupCompaniesSection.vue?vue&type=template&id=2b85f8a6&scoped=true&"
import script from "./EventPopupCompaniesSection.vue?vue&type=script&lang=ts&"
export * from "./EventPopupCompaniesSection.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopupCompaniesSection.vue?vue&type=style&index=0&id=2b85f8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85f8a6",
  null
  
)

export default component.exports